import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Select, Spinner } from "@chakra-ui/react";

const JournalSelectById = ({
  label = "Select Journal",
  selectedJournalId,
  onChange,
  type,
  size = "md",
  height,
}) => {
  const [journals, setJournals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJournals = async () => {
      setLoading(true);
      try {
        const url = new URL("https://ledgers.poc.mrc.ai/api/journals/headers");
        if (type) url.searchParams.set("type", type);

        const res = await fetch(url.toString());
        const json = await res.json();

        if (Array.isArray(json)) {
          const sorted = [...json].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          setJournals(sorted);
        } else {
          setJournals([]);
        }
      } catch (err) {
        console.error("Failed to fetch journals:", err);
        setJournals([]);
      } finally {
        setLoading(false);
      }
    };

    fetchJournals();
  }, [type]);

  const handleSelect = (id) => {
    const selected = journals.find((j) => j._id === id);
    onChange(selected ? { id: selected._id, name: selected.name } : null);
  };

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      {loading ? (
        <Spinner />
      ) : (
        <Select
          placeholder="Select journal..."
          value={selectedJournalId || ""}
          onChange={(e) => handleSelect(e.target.value)}
          size={size}
          height={height}
        >
          {journals.length > 0 ? (
            journals.map((journal) => (
              <option key={journal._id} value={journal._id}>
                {journal.name}
              </option>
            ))
          ) : (
            <option disabled>No journals available</option>
          )}
        </Select>
      )}
    </FormControl>
  );
};

export default JournalSelectById;
